/**
 * @flow
 * @relayHash 829f6909ed06429335cc81d5c7718946
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type RevokeOauthAccessInput = {|
  integrationId: string
|};
export type RevokeOauthAccessMutationVariables = {|
  input: RevokeOauthAccessInput
|};
export type RevokeOauthAccessMutationResponse = {|
  +revokeOauthAccess: {|
    +success: boolean
  |}
|};
export type RevokeOauthAccessMutation = {|
  variables: RevokeOauthAccessMutationVariables,
  response: RevokeOauthAccessMutationResponse,
|};
*/


/*
mutation RevokeOauthAccessMutation(
  $input: RevokeOauthAccessInput!
) {
  revokeOauthAccess(input: $input) {
    success
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "RevokeOauthAccessInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "revokeOauthAccess",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RevokeOauthAccessPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "success",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "RevokeOauthAccessMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "RevokeOauthAccessMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "RevokeOauthAccessMutation",
    "id": null,
    "text": "mutation RevokeOauthAccessMutation(\n  $input: RevokeOauthAccessInput!\n) {\n  revokeOauthAccess(input: $input) {\n    success\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '26797becd7d7be1c86b0e5d6ed689c10';
module.exports = node;
